// Entry point for the build script in package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

// Turbo's progress bar trickles without a ceiling, so long requests can show
// >100%. Cap the indeterminate phase below completion; setValue(1) still runs
// when the request finishes.
// Turbo 8 keeps the bar on the browser adapter, not the session.
const progressBar = Turbo.session.adapter.progressBar
const INDETERMINATE_MAX = 0.9

if (progressBar) {
  progressBar.trickle = () => {
    if (progressBar.value >= INDETERMINATE_MAX) return

    progressBar.setValue(Math.min(INDETERMINATE_MAX, progressBar.value + Math.random() / 100))
  }

  progressBar.refresh = () => {
    requestAnimationFrame(() => {
      const width = Math.min(100, 10 + progressBar.value * 90)
      progressBar.progressElement.style.width = `${width}%`
    })
  }
}
